import { addLocale } from "primereact/api";
import ltLocale from "../../utils/locale/lt.json";
import plLocale from "../../utils/locale/pl.json";

/**
 * translation source: https://github.com/primefaces/primelocale
 */
const setPrimeLocales = () => {
  addLocale("en", { firstDayOfWeek: 1 });
  addLocale("lt", ltLocale.lt);
  addLocale("pl", plLocale.pl);
};

export default setPrimeLocales;
